import { Component, ViewModel, View } from "binder";
import  { PopupView } from "./popup-view"

export class PopupViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.preferredwidth = "auto";
        this.origin = new Position(0,0);
        this.isShowing = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new PopupView();
    }
    public getTypeId(): string {
        return "VM-BF8EBFC9-3410-4B89-B3AF-F472D4304C71"
    }
    public set usebody(v: boolean) { this._usebody = v; } public get usebody(): boolean { return this._usebody;} private _usebody: boolean;
    public set origin(v: Position) { this._origin = v; } public get origin(): Position { return this._origin;} private _origin: Position;
    public set isShowing(v: boolean) { 
        this._isShowing = v; 
        if(this.showing!=v){
            this.showing = v;
        }
    } public get isShowing(): boolean { return this._isShowing;} private _isShowing: boolean;
    public set showing(v: boolean) { 
        this._showing = v; 
        if(this.isShowing!=v){
            this.isShowing = v;
        }
    } public get showing(): boolean { return this._showing;} private _showing: boolean;
    public set preferredwidth(v: string) { this._preferredwidth = v; } public get preferredwidth(): string { return this._preferredwidth;} private _preferredwidth: string;
    
}

export class Position{
    public x:number;
    public y:number;
    public width:number;
    public height:number;

    constructor(x:number,y:number,width?:number,height?:number) {
        this.x = x;
        this.y = y;        
        this.width = width || 0;
        this.height = height || 0;
    }
}